import React, { useState, useEffect } from "react";
import processPng from "../assets/img/svgLogin.png";
import ataLogo from "../assets/img/logo_ata.png";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import { login, verifyOTP,resendOTP } from "../services/authService";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";

function Auth() {
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
    OTP: "",
    AppType: "Aryabhtta",
  });

  const [animate, setAnimate] = useState(false);
  const [resp, setResp] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showOTPPassword, setShowOTPPassword] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(30);
  const [resending, setResending] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  // Countdown for resend button
  useEffect(() => {
    let timer;
    if (otpModal && resendTimer > 0) {
      timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [otpModal, resendTimer]);

  const handleOTP = async () => {
    setOtpLoading(true);
    try {
      const decodeJWT = jwt_decode(resp);
      const response = await verifyOTP(decodeJWT.uid, credentials.OTP.trim());

      if (response && decodeJWT.role.includes("aryabhatta")) {
        localStorage.setItem("access_token", resp);
        window.location = "/dashboard/overview";
      } else {
        toast.error("Invalid OTP or unauthorized access");
      }
    } catch (error) {
      toast.error("OTP is expired or invalid");
    } finally {
      setOtpLoading(false);
    }
  };

const handleResendOTP = async () => {
  // Prevent resend if already sending or timer is active
  if (resending || resendTimer > 0) return;

  try {
    setResending(true); // Lock resend button immediately

    const decodeJWT = jwt_decode(resp);
    await resendOTP({ userId: decodeJWT.uid });

    toast.success("OTP has been resent to your registered email.");
    setResendTimer(30); // Start cooldown timer
  } catch (err) {
    toast.error("Failed to resend OTP.");
  } finally {
    setResending(false); // Unlock after request completes
  }
};


  const handleLogin = async (e) => {
    e.preventDefault();
    if (!credentials.username || !credentials.password) {
      toast.error("Username and password are required.");
      return;
    }

    try {
      setAnimate(true);
      const result = await login(credentials);
      if (result) {
        setResp(result);
        setOtpModal(true);
        setResendTimer(30); // Start timer on modal open
      }
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error(error.response.data.Message || "Login failed.");
      }
    } finally {
      setAnimate(false);
    }
  };

  return (
    <div className="main-container">
      <div className="left-bag">
        <div className="content-box">
          <div>
            <h1>We’re so happy you’re here!</h1>
            <h3>Experience the new work flow we've created just for you.</h3>
            <h4 className="feature">Simple, Intuitive, Efficient..</h4>
          </div>
          <img className="log-img" src={processPng} alt="process" />
        </div>
      </div>

      <div className="right-bag">
        <div className="form-container">
          <div className="df_login aic">
            <img src={ataLogo} className="ata-digital" alt="logo" />
          </div>
          <h5 className="advertise">
            A digitized workplace powered by Quloi.Inc
          </h5>

          <div className="form-login">
            <Form onSubmit={handleLogin} style={{ width: "100%" }}>
              <Form.Group className="mb-3">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  onChange={handleChange}
                  name="username"
                  value={credentials.username}
                  placeholder="Enter username"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <InputGroup>
                  <Form.Control
                    onChange={handleChange}
                    name="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter password"
                  />
                  <InputGroup.Text className="transparent">
                    <span onClick={() => setShowPassword((prev) => !prev)}>
                      {showPassword ? <Icon.Eye /> : <Icon.EyeSlash />}
                    </span>
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>

              <div className="mb-3 text-end">
                <Link to="/forgot-password" className="forgot-password-link">
                  Forgot Password?
                </Link>
              </div>

              <Button
                variant="primary"
                className="login-btn"
                type="submit"
                disabled={animate}
              >
                {animate ? "Logging in..." : "Log in"}
              </Button>
            </Form>
          </div>
        </div>
      </div>

      {/* OTP MODAL */}
      <Modal show={otpModal} onHide={() => setOtpModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Enter OTP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>OTP</Form.Label>
            <InputGroup>
              <Form.Control
                name="OTP"
                type={showOTPPassword ? "text" : "password"}
                placeholder="Enter OTP"
                onChange={handleChange}
              />
              <InputGroup.Text className="transparent">
                <span onClick={() => setShowOTPPassword((prev) => !prev)}>
                  {showOTPPassword ? <Icon.Eye /> : <Icon.EyeSlash />}
                </span>
              </InputGroup.Text>
            </InputGroup>
          </Form.Group>
          <div className="text-end mt-2">
      <Button
  variant="link"
  className="p-0"
  onClick={handleResendOTP}
  disabled={resendTimer > 0 || resending}
>
  {resendTimer > 0
    ? `Resend OTP in ${resendTimer}s`
    : resending
    ? "Sending..."
    : "Resend OTP"}
</Button>


          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setOtpModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleOTP} disabled={otpLoading}>
            {otpLoading ? "Verifying..." : "Verify OTP"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Auth;
